<app-header></app-header>
<div class="min-h-screen flex justify-center items-center px-4 sm:px-6 bg-cover bg-center">
    <div class="flex justify-center w-full max-w-[320px] sm:max-w-md md:max-w-xl">
        <div class="flex flex-col bg-white p-4 sm:p-6 md:p-8 w-full rounded-lg shadow-lg">
            <div class="flex justify-center mb-6 sm:mb-8 md:mb-10">
                <img src="assets/images/pruforce-corporate.png" class="h-16 sm:h-20 md:h-24" alt="Pruforce Corporate Logo" />
            </div>

            <h2 class="text-left text-base sm:text-lg md:text-xl font-medium text-gray-700 mb-4 sm:mb-6">
                {{ 'SALESFORCE.VERIFY.TITLE' | translate }}
            </h2>

            <div class="flex items-center p-3 mb-4 text-xs sm:text-sm text-green-800 rounded-lg bg-green-50 border border-green-200">
                <svg class="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                <span class="sr-only">Success</span>
                <div class="font-medium">
                    <span *ngIf="selectedMethod === 'email'">
                        {{ 'SALESFORCE.VERIFY.EMAIL_SENT' | translate }}
                    </span>
                    <span *ngIf="selectedMethod === 'wab'">
                        {{ 'SALESFORCE.VERIFY.WHATSAPP_SENT' | translate }}
                    </span>
                </div>
            </div>

    <div *ngIf="errorMessage"
        class="text-center p-3 sm:p-4 mb-3 sm:mb-4 text-xs sm:text-sm font-medium text-red-800 rounded-lg bg-red-100">
        {{ errorMessage }}
    </div>

    <div class="mb-3 sm:mb-4">
        <label for="otp" class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
            {{ 'SALESFORCE.VERIFY.VERIFICATION_CODE' | translate }}
        </label>
        <form [formGroup]="otpForm" autocomplete="off">
            <div formArrayName="digits" class="flex justify-center space-x-2 sm:space-x-3 my-4">
                <input *ngFor="let ctrl of otpControls; let i = index" #otpInput type="text" maxlength="1"
                    class="w-10 h-12 sm:w-12 sm:h-14 text-center text-lg sm:text-xl font-semibold border rounded-md border-gray-300 focus:border-blue-500 focus:outline-none"
                    [formControlName]="i" (input)="onOtpInput($event, i)" (keydown)="onOtpKeydown($event, i)"
                    (paste)="onOtpPaste($event)" inputmode="numeric" autocomplete="one-time-code">
            </div>
        </form>
    </div>

    <button (click)="verifyOTP()" [disabled]="!isFormValid() || loading"
        class="w-full py-2.5 sm:py-3 px-4 rounded-full mb-3 sm:mb-4 font-medium text-base sm:text-lg min-h-[48px]"
        [ngClass]="{
            'opacity-50 cursor-default bg-gray-800': !isFormValid() || loading,
            'hover:bg-red-700 bg-red-600 text-white': isFormValid() && !loading
        }">
        <span *ngIf="!loading">{{ 'SALESFORCE.VERIFY.VERIFY_BUTTON' | translate }}</span>
        <span *ngIf="loading" class="flex items-center justify-center">
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg"
                fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                </circle>
                <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                </path>
            </svg>
            {{ 'SALESFORCE.VERIFY.VERIFYING' | translate }}
        </span>
    </button>

    <div class="text-center text-xs sm:text-sm text-gray-600">
        <div>
            {{ 'SALESFORCE.VERIFY.DIDNT_RECEIVE_CODE' | translate }}
        </div>

        <!-- Timer display -->
        <div *ngIf="timer > 0" class="text-center mt-2 text-xs text-gray-500 mb-4">
            {{ 'SALESFORCE.VERIFY.RESEND_IN_SECONDS' | translate: {seconds: timer} }}
        </div>

        <!-- Switch method option - only available if no method switch yet -->
        <div *ngIf="timer > 0 && !hasTriedAnyMethod" class="mt-2 text-center">
            <button *ngIf="selectedMethod === 'email'" (click)="switchToWab()" [disabled]="loading || debouncing"
                class="hover:underline text-xs sm:text-sm min-h-[44px] px-3"
                style="color: #ed1b2e"
                [ngClass]="{'opacity-50 cursor-default': loading || debouncing}">
                {{ 'SALESFORCE.VERIFY.SEND_TO_WHATSAPP_INSTEAD' | translate }}
            </button>
            <button *ngIf="selectedMethod === 'wab'" (click)="switchToEmail()" [disabled]="loading || debouncing"
                class="hover:underline text-xs sm:text-sm min-h-[44px] px-3"
                style="color: #ed1b2e"
                [ngClass]="{'opacity-50 cursor-default': loading || debouncing}">
                {{ 'SALESFORCE.VERIFY.SEND_TO_EMAIL_INSTEAD' | translate }}
            </button>
        </div>

        <!-- Resend with same method - when timer expires -->
        <div *ngIf="timer === 0" class="mt-2 text-center">
            <button (click)="resendCode()" [disabled]="loading || debouncing"
                class="hover:underline text-xs sm:text-sm min-h-[44px] px-3"
                style="color: #ed1b2e"
                [ngClass]="{'opacity-50 cursor-default': loading || debouncing}">
                <span *ngIf="selectedMethod === 'email'">{{ 'SALESFORCE.VERIFY.RESEND_TO_EMAIL' | translate }}</span>
                <span *ngIf="selectedMethod === 'wab'">{{ 'SALESFORCE.VERIFY.RESEND_TO_WHATSAPP' | translate }}</span>
            </button>
        </div>

        <div *ngIf="timer === 0" class="mt-1 text-center">
            <span class="text-gray-500 text-xs sm:text-sm">{{ 'SALESFORCE.VERIFY.OR' | translate }}</span>
        </div>

        <!-- Switch to other method - when timer expires -->
        <div *ngIf="timer === 0" class="mt-2 text-center">
            <button *ngIf="selectedMethod === 'email'" (click)="switchToWab()" [disabled]="loading || debouncing"
                class="hover:underline text-xs sm:text-sm min-h-[44px] px-3"
                style="color: #ed1b2e"
                [ngClass]="{'opacity-50 cursor-default': loading || debouncing}">
                {{ 'SALESFORCE.VERIFY.SEND_TO_WHATSAPP_INSTEAD' | translate }}
            </button>
            <button *ngIf="selectedMethod === 'wab'" (click)="switchToEmail()" [disabled]="loading || debouncing"
                class="hover:underline text-xs sm:text-sm min-h-[44px] px-3"
                style="color: #ed1b2e"
                [ngClass]="{'opacity-50 cursor-default': loading || debouncing}">
                {{ 'SALESFORCE.VERIFY.SEND_TO_EMAIL_INSTEAD' | translate }}
            </button>
        </div>
        </div>
    </div>
</div>
</div>
